export const init = () => {
    let navBurgerButtonContainer = document.getElementById('nav-mobile');
    let navBurgerLink = navBurgerButtonContainer.getElementsByTagName('a')[0];

    let dropDowns = document.querySelector('nav ul li > a:not(:only-child)');
    dropDowns.onclick = toggleDropdown;
    document.querySelector('html').onclick = () => {
        document.querySelector('.nav-dropdown').classList.remove("active");
        document.querySelector('.nav-list').classList.remove("active");
        navBurgerLink.classList.remove('active');
    };

    navBurgerButtonContainer.onclick = event => {
        showMobileMenu();
        toggleBurgerIcon(navBurgerLink);
        event.stopPropagation();
    };
};

const showMobileMenu = _ => {
    document.querySelector('nav .nav-list').classList.toggle('active');
};

const toggleBurgerIcon = (navBurgerButton) => {
    navBurgerButton.classList.toggle('active');
};

const toggleDropdown = (event) => {
    event.preventDefault();
    event.target.parentNode.getElementsByClassName('nav-dropdown')[0].classList.toggle('active');
    // document.querySelectorAll('.nav-dropdown').not($(this).siblings()).hide();
    event.stopPropagation();
};





// (function($) {
//     $(function() {
//         $('nav ul li > a:not(:only-child)').click(function(e) {
//             $(this).siblings('.nav-dropdown').toggle();
//             $('.nav-dropdown').not($(this).siblings()).hide();
//             e.stopPropagation();
//         });
//         $('html').click(function() {
//             $('.nav-dropdown').hide();
//         });
//     });
//     document.querySelector('#nav-toggle').addEventListener('click', function() {
//         this.classList.toggle('active');
//     });
//     $('#nav-toggle').click(function() {
//         $('nav ul').toggle();
//     });
// })(jQuery);
